// extracted by mini-css-extract-plugin
export var childrenContainer = "_ba-0";
export var virtualScrollArea = "_ba-1";